'use client';

// Third-party Imports
import classnames from 'classnames';

// Component Imports
import UserDropdown from '@components/layout/shared/UserDropdown';
import NavToggle from './NavToggle';

// Util Imports
import { useSettings } from '@/@core/hooks/useSettings';
import useVerticalNav from '@/@menu/hooks/useVerticalNav';
import { NavCollapseIcons } from '@/@menu/vertical-menu';
import { AppIcon } from '@/components/AppIcon';
import { VMSBreadcrumb } from '@/components/breadcrumb';
import { PermissionGuard } from '@/components/PermissionGuard';
import { PERMISSIONS } from '@/configs/permissions';
import { useAppSelector } from '@/redux-store/hooks';
import { verticalLayoutClasses } from '@layouts/utils/layoutClasses';
import AppConfigDropdown from '../shared/AppConfigDropdown';
import NotificationDropdown from '../shared/NotificationDropdown/NotificationDropdown';
import TranslationDropdown from '../shared/TranslationDropdown';

const NavbarContent = () => {
    const verticalNavOptions = useVerticalNav();
    const { updateSettings } = useSettings();

    const { isCollapsed, isHovered } = verticalNavOptions;

    const breadcrumbItems = useAppSelector(
        state => state.breadcrumb.breadcrumbItems
    );

    return (
        <div
            className={classnames(
                verticalLayoutClasses.navbarContent,
                'flex items-center justify-between gap-4 is-full'
            )}
        >
            <div className='flex items-center gap-4'>
                <NavToggle />
                {!isHovered && (
                    <NavCollapseIcons
                        lockedIcon={<AppIcon name='toggleSidebar' />}
                        unlockedIcon={<AppIcon name='toggleSidebar' />}
                        closeIcon={<i className='ri-close-line text-xl' />}
                        className='text-textSecondary'
                        onClick={() =>
                            updateSettings({
                                layout: !isCollapsed ? 'collapsed' : 'vertical',
                            })
                        }
                    />
                )}
                <VMSBreadcrumb items={breadcrumbItems} />
            </div>
            <div className='flex items-center gap-2'>
                {/* <ModeDropdown /> */}
                <PermissionGuard perm={[PERMISSIONS.Config.GetList]}>
                    <AppConfigDropdown />
                </PermissionGuard>
                <NotificationDropdown />
                <TranslationDropdown />
                <UserDropdown />
            </div>
        </div>
    );
};

export default NavbarContent;
